import React, { useRef } from 'react';
import { useSlidingIndicator } from '../../../hooks/useSlidingIndicator';

const TABS = [
  { id: 'profile_info', label: 'Dados gerais' },
  { id: 'account_security', label: 'Segurança' },
  { id: 'financial', label: 'Info do plano' },
  { id: 'credit_cards', label: 'Cartões de crédito' },
  { id: 'queries', label: 'Consultas Jusfinder' },
  { id: 'features', label: 'Utilização' },
  { id: 'credits', label: 'Benefícios' },
  { id: 'products', label: 'Produtos' },
];

export default function Tabs({ tab, setTab }) {
  const ref = useRef(null);
  // Sublinhado único que desliza até a aba ativa (em vez de cada aba pintar o seu).
  const indicator = useSlidingIndicator(ref, '[aria-selected="true"]', tab);

  return (
    <div ref={ref} className="cd-tabs" role="tablist">
      {TABS.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={tab === id}
          className="cd-tab"
          onClick={() => setTab(id)}
        >
          {label}
        </button>
      ))}
      {indicator && (
        <span
          aria-hidden="true"
          className="cd-tab-indicator"
          style={{
            width: indicator.w,
            transform: `translateX(${indicator.x}px)`,
          }}
        />
      )}
    </div>
  );
}
